
import { z } from "zod";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { UseFormReturn } from "react-hook-form";

export const formSchema = z.object({
  name: z.string().min(2, {
    message: "Name must be at least 2 characters.",
  }),
  email: z.string().email({
    message: "Please enter a valid email address.",
  }),
  message: z.string().min(10, {
    message: "Message must be at least 10 characters.",
  }),
  interested_in_early_access: z.boolean().default(false),
  interested_in_investment: z.boolean().default(false),
  interested_in_team: z.boolean().default(false),
});

export type ContactFormValues = z.infer<typeof formSchema>;

export const useContactFormSubmit = (form: UseFormReturn<ContactFormValues>) => {
  const submitForm = async (values: ContactFormValues) => {
    try {
      console.log("Submitting form with values:", values);
      
      // Call the edge function directly for both logging and database storage
      const { data, error } = await supabase.functions.invoke("send-contact-notification", {
        body: values,
      });

      if (error) {
        console.error("Function error:", error);
        throw new Error("Failed to send your message. Please try again.");
      }
      
      // Show success message
      toast({
        title: "Message sent successfully!",
        description: "We'll get back to you as soon as possible.",
        variant: "default",
      });
      
      // Reset the form
      form.reset();
      
    } catch (error: any) {
      console.error("Error submitting form:", error);
      toast({
        title: "Error sending message",
        description: error.message || "Please try again later.",
        variant: "destructive",
      });
    }
  };

  return submitForm;
};
